import styled, { css } from 'styled-components';
import { body2, colors, monospaceCaption, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { ErrorText as ErrorMessage } from 'ui/formField';
import { Tooltip } from 'ui/tooltip';
import { BaseBadge } from 'ui/badge/Badge.styles';

const commonStyles = css`
  ${body2}
  display: flex;
  gap: ${spacing.half};
`;

export const AttributeWrapper = styled.div`
  margin-top: ${spacing.plusHalf};
  > * {
    margin: ${spacing.half} 0;
  }
`;

export const AttributeDetails = styled.div`
  ${commonStyles}
  align-items: center;
`;

export const RadioRow = styled.div`
  ${commonStyles}
  align-items: flex-start;
`;

export const AttributeDetailsDisabledTooltip = styled(Tooltip)`
  ${commonStyles}
  align-items: center;
`;

export const RadioRowDisabledTooltip = styled(Tooltip)`
  ${commonStyles}
  align-items: flex-start;
`;

export const InputWrapper = styled.div`
  margin-top: ${spacing.half};
  width: fit-content;
  input {
    width: ${pxToRem(75)};
  }
`;

export const CodeBlock = styled.code`
  ${monospaceCaption}
  margin-left: ${spacing.quarter};
  color: ${colors.textInfo};
  background-color: ${colors.backgroundInfoSubtle};
`;

export const ErrorWrapper = styled.div`
  display: flex;
  margin-left: ${pxToRem(32)};
`;
export const ErrorText = styled(ErrorMessage)`
  margin: 0;
`;

export const RadioRowText = styled.div<{ $isDisabled: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: ${colors.textDisabled};
      ${BaseBadge} {
        color: ${colors.textDisabled};
      }
  `}
`;

export const LastTouchLabelWrapper = styled.div`
  display: inline-flex;
  gap: ${spacing.half};
  align-items: center;
  margin-bottom: -${spacing.half};
`;
